<template>
  <div class="bg-white max-w-lg my-4">
    <a-list bordered :data-source="compareDataSources">
      <h3 slot="header" class="text-xl font-semibold">DATA SOURCE CONFLICTS</h3>
      <a-list-item slot="renderItem" slot-scope="item">
        <div>
          <h4 class="text-lg font-semibold">
            {{ item.period.year }} / {{ item.period.month }} -
            {{ item.class.name }}
          </h4>
          <div class="w-full conflict-container">
            <data-conflict-entry
              source="SYMBIOTICS"
              :canReportValue="!!item.symbioticsShareValue"
              :shareValue="item.symbioticsShareValue"
              :dividend="item.symbioticsDividend"
              @useButtonClicked="useSymbioticsValues(item)"
            />
            <data-conflict-entry
              source="REFINITIV"
              :canReportValue="!!item.refinitivShareValue"
              :shareValue="item.refinitivShareValue"
              :dividend="item.refinitivDividend"
              @useButtonClicked="useRefinitivValues(item)"
            />
            <data-conflict-entry
              source="TAMEO"
              :shareValue="item.tameoShareValue"
              :dividend="item.tameoDividend"
            />
          </div>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import DataConflictEntry from './DataConflictEntry.vue'

export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
  },
  components: {
    DataConflictEntry,
  },
  apollo: {
    compareDataSources: {
      query: gql`
        query CompareDataSources($fundId: Uuid!) {
          compareDataSources(fundId: $fundId) {
            period {
              year
              month
            }
            class {
              id
              name
              currency
            }
            symbioticsShareValue
            symbioticsDividend
            refinitivShareValue
            refinitivDividend
            tameoShareValue
            tameoDividend
          }
        }
      `,
      variables() {
        return {
          fundId: this.fund.key,
        }
      },
    },
  },
  data() {
    return {
      compareDataSources: [],
    }
  },
  methods: {
    async useSymbioticsValues(item) {
      const input = this.buildUpdateClassReportInput(
        item,
        item.symbioticsShareValue,
        item.symbioticsDividend,
      )
      await this.updateClassReport(input)
      this.$apollo.queries.compareDataSources.refetch()
    },
    async useRefinitivValues(item) {
      const input = this.buildUpdateClassReportInput(
        item,
        item.refinitivShareValue,
        item.refinitivDividend,
      )
      await this.updateClassReport(input)
      this.$apollo.queries.compareDataSources.refetch()
    },
    buildUpdateClassReportInput(item, shareValue, dividend) {
      return {
        fundId: this.fund.key,
        fundName: this.fund.name,
        fundCurrency: this.fund.currency,
        classId: item.class.id,
        className: item.class.name,
        classCurrency: item.class.currency,
        year: item.period.year,
        month: item.period.month,
        shareValue: shareValue,
        dividend: dividend,
      }
    },
    async updateClassReport(input) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: UpdateClassReportInput) {
            updateClassReport(input: $input) {
              fundId
              classId
              year
              month
            }
          }
        `,
        variables: {
          input,
        },
      })
    },
  },
}
</script>

<style scoped>
.conflict-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
